import React, {useEffect} from 'react';
import useApi from '../../../utility/Hooks/Api/useApi';
import {VehicleApi} from "../../../services/Api/VehicleApi";
import CustomSelect from '../Custom/CustomSelect';
import {CompanyApi} from "../../../services/Api/CompanyApi";

export default function VehicleSelect({onChange, label, required}) {
    const {request, data} = useApi();
    const {request: companyRequest, data: companyData} = useApi();

    useEffect(() => {
        request(VehicleApi.getVehicles());
        companyRequest(CompanyApi.getCompanies());
    }, []);

    // Helper function to get case-insensitive property from an object
    const getCaseInsensitive = (obj, key) => {
        if (!obj) return undefined;
        const lowerCaseKey = key.toLowerCase();
        return Object.keys(obj).reduce((result, currentKey) => {
            return currentKey.toLowerCase() === lowerCaseKey ? obj[currentKey] : result;
        }, undefined);
    };

    const getCompanyName = (id) => {
        const company = companyData?.find(function (element) {
            return getCaseInsensitive(element, "customer id") === id.toString() || getCaseInsensitive(element, "id").toString() === id.toString();
        });
        return company ? `${getCaseInsensitive(company, "company name")} (${getCaseInsensitive(company, "customer id")})` : "No assigned owner";
    };

    const VehicleOptions = () => {
        return data.map((vehicle) => {
            const owner = getCaseInsensitive(vehicle, "owner");
            const reference = getCaseInsensitive(vehicle, "reference");
            const id = getCaseInsensitive(vehicle, "id");
            return { value: JSON.stringify(vehicle), label: `${id} - ${getCompanyName(owner)} - ${reference}` };
        });
    };

    return (
        <>
            <CustomSelect
                options={data ? VehicleOptions() : []}
                placeHolder={`Select a Vehicle`}
                onChange={(e) => onChange(e)}
                isSearchable
            />
        </>
    );
}
